import { createContext } from "react";

interface RootContextType {
    isScreenTooSmall: boolean;
    isScreenWayTooSmall: boolean;
}

const rootContextDefaultValue = {
    isScreenTooSmall: false,
    isScreenWayTooSmall: false
}

export const rootContext = createContext<RootContextType>(
    rootContextDefaultValue
)